(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("MultiCarousel", [], factory);
	else if(typeof exports === 'object')
		exports["MultiCarousel"] = factory();
	else
		root["MultiCarousel"] = factory();
})(this, function() {
return 